import React from "react";
import {directMessageSetReceiverTagOwner} from "../../exhibition_actions";
import {useDispatch} from "react-redux";
import ChatMessageTagOwnerImage from "./chat_message_tag_owner_image";

export default function SearchResultContent({setSearchResults, searchResults, translations}) {
  const dispatch = useDispatch()
  return <>
    <div className="row">
      <div className="col-12">
        <div className="back-button" onClick={() => {
          dispatch(directMessageSetReceiverTagOwner(null))
          setSearchResults(null)
        }}>
          {translations.backText || "Back"}
        </div>
      </div>
    </div>
    {searchResults.length === 0 && <div className="row">
      <div className="col-12 text-center" style={{paddingTop: "1rem"}}>
        {translations.userNotFoundText || "No user found"}
      </div>
    </div>}
    <div className="row">
      <div className="col-12">
        {searchResults.map((result) => {
          return <div key={result.id} className="row">
            <div className="col-12" onClick={() => {
              setSearchResults(null)
              dispatch(directMessageSetReceiverTagOwner(result))
            }}>
              <div className="search-result">
                <strong className={result.moderator ? "moderator" : ""}>
                  <ChatMessageTagOwnerImage tagOwner={result} />
                  {" " + result.name}
                </strong>
              </div>
            </div>
          </div>
        })}
      </div>
    </div>
  </>;
}